import { CustomerApplicationSummary } from "Hooks/Api/apiCustomerApplications";
import { OverviewWidget } from "Views/Components/Widgets/OverviewWidget";

export function CustomerApplicationBusinessInfoWidget(props: { model: CustomerApplicationSummary }) {
	const { model } = props;
	return (
		<OverviewWidget
			title="Business Info"
			className="business-info"
		>
		</OverviewWidget>
	)
}